// Publishes the header's height as --site-header-height, so a section can be
// sized against the screen below it (see .hero-carousel--full). The header
// changes height between phone and desktop, and again when the search row
// opens, so it is measured rather than hard-coded.
(function () {
  var group = document.querySelector('.shopify-section-group-header-group');
  if (!group) return;

  function publish() {
    document.documentElement.style.setProperty(
      '--site-header-height',
      group.offsetHeight + 'px',
    );
  }

  publish();
  if (window.ResizeObserver) {
    new ResizeObserver(publish).observe(group);
  } else {
    window.addEventListener('resize', publish);
  }
})();

// Header on phones and tablets: the menu drawer and the search row. Only one
// of the two is open at a time. Keep this file tiny — most interactivity in a
// Shopify theme comes from plain links and forms, not JavaScript.
(function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  var search = document.querySelector('[data-search-panel]');
  var bar = document.querySelector('.site-header__top');
  if (!navToggle || !nav) return;

  function setState(el, button, isOpen) {
    if (!el) return;
    el.classList.toggle('is-open', isOpen);
    if (button) {
      button.classList.toggle('is-open', isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  // The drawer takes exactly the screen below the bar: a short menu still
  // covers the page, a long one scrolls inside itself.
  function sizeDrawer() {
    if (!nav.classList.contains('is-open')) return;
    var bottom = bar ? bar.getBoundingClientRect().bottom : 0;
    nav.style.height = Math.max(0, window.innerHeight - bottom) + 'px';
  }

  function openNav(isOpen) {
    setState(nav, navToggle, isOpen);
    document.body.classList.toggle('is-nav-open', isOpen);
    if (isOpen) {
      setState(search, searchToggle, false);
      sizeDrawer();
    } else {
      nav.style.height = '';
    }
  }

  function openSearch(isOpen) {
    setState(search, searchToggle, isOpen);
    if (isOpen) {
      openNav(false);
      var input = search.querySelector('input');
      if (input) input.focus();
    }
  }

  navToggle.addEventListener('click', function () {
    openNav(!nav.classList.contains('is-open'));
  });

  if (searchToggle && search) {
    searchToggle.addEventListener('click', function () {
      openSearch(!search.classList.contains('is-open'));
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (nav.classList.contains('is-open')) openNav(false);
    if (search && search.classList.contains('is-open')) openSearch(false);
  });

  window.addEventListener('resize', function () {
    // Back on desktop the drawer is a normal row again — drop the leftovers.
    if (window.innerWidth >= 990) {
      openNav(false);
      if (search) setState(search, searchToggle, false);
    } else {
      sizeDrawer();
    }
  });
})();

// Custom search clear (✕): works for any search field marked with a
// [data-search-clear] button (header bar, search results page, …). The button
// shows only while the field has text; clicking it clears and refocuses.
// Replaces the browser's native blue clear cross.
(function () {
  var clears = document.querySelectorAll('[data-search-clear]');
  Array.prototype.forEach.call(clears, function (btn) {
    var form = btn.closest('form');
    var input = form && form.querySelector('input[type="search"]');
    if (!input) return;
    function sync() { btn.hidden = input.value.length === 0; }
    input.addEventListener('input', sync);
    btn.addEventListener('click', function () {
      input.value = '';
      sync();
      input.focus();
    });
    sync();
  });
})();

// Gift wrap: €1 per wrapped unit, charged through the unlisted product
// "cadeauverpakking". Two things carry it, on purpose:
//   - every wrapped line keeps a "Cadeauverpakking: Ja" property, so the order
//     says WHICH items to wrap;
//   - one separate line carries the money, SKU 990000000000999, which the Mplus
//     order push books straight onto the gift-wrap article.
// This keeps that line's quantity equal to the number of wrapped units. It is
// idempotent and only writes when the two disagree, so every entry point (the
// checkbox, a page load, a removal in the drawer) can call it without
// coordinating with the others. Resolves true when it changed the cart.
window.theme = window.theme || {};

// The count shown in the header and drawer. The gift-wrap line is an add-on
// under the product it belongs to, not an article, so it is left out; the
// Liquid side does the same in snippets/cart-visible-count.liquid.
window.theme.visibleItemCount = function (cart) {
  var id = window.theme.giftWrapVariantId;
  return cart.items.reduce(function (n, item) {
    return item.variant_id === id ? n : n + item.quantity;
  }, 0);
};

window.theme.syncGiftWrap = function () {
  var id = window.theme.giftWrapVariantId;
  if (!id) return Promise.resolve(false);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };

  return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var wanted = 0;
      var wrap = null;
      cart.items.forEach(function (item) {
        if (item.variant_id === id) { wrap = item; return; }
        if (item.properties && item.properties['Cadeauverpakking']) wanted += item.quantity;
      });
      if ((wrap ? wrap.quantity : 0) === wanted) return false;

      var request = wrap
        ? fetch(root + 'cart/change.js', { method: 'POST', headers: headers, body: JSON.stringify({ id: wrap.key, quantity: wanted }) })
        : fetch(root + 'cart/add.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: [{ id: id, quantity: wanted }] }) });
      // A refused write (say the product went missing) reports "unchanged".
      // Reporting true there would make every caller reload into the same
      // refusal, forever.
      return request.then(function (r) { return r.ok; });
    })
    .catch(function () { return false; });
};

// Cart drawer: AJAX add-to-cart opens a slide-in panel; the header cart icon
// opens it too; "Verwijder" removes a line. Uses Shopify's cart + section-
// rendering APIs so totals/counts stay correct. Degrades to normal /cart
// navigation without JS.
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Update every header cart count from the two localised templates ("1 item" /
  // "2 items"), swapping in the real number so pluralisation stays correct.
  function updateCount(count) {
    var els = document.querySelectorAll('[data-cart-count-text]');
    Array.prototype.forEach.call(els, function (el) {
      var tmpl = count === 1 ? el.getAttribute('data-count-one') : el.getAttribute('data-count-other');
      if (tmpl) el.textContent = tmpl.replace(/\d[\d.,]*/, count);
    });
    // The same number as the badge on the icon (phones/tablets), hidden at zero.
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Replace the drawer's contents from a re-rendered section and sync the count.
  function render(sectionHtml) {
    if (!sectionHtml) return;
    var fresh = new DOMParser()
      .parseFromString(sectionHtml, 'text/html')
      .querySelector('[data-cart-drawer]');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    var count = parseInt(fresh.getAttribute('data-cart-count'), 10);
    if (!isNaN(count)) {
      drawer.setAttribute('data-cart-count', count);
      updateCount(count);
    }
  }

  function removeLine(line) {
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: 0, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart.sections && cart.sections['cart-drawer']);
        if (cart.items) updateCount(window.theme.visibleItemCount(cart));
        // The removed line may have been wrapped; re-render if the wrap line moved.
        return window.theme.syncGiftWrap().then(function (changed) {
          if (!changed) return;
          return fetch(root + '?sections=cart-drawer')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              render(sections['cart-drawer']);
              return fetch(root + 'cart.js').then(function (r) { return r.json(); });
            })
            .then(function (fresh) { updateCount(window.theme.visibleItemCount(fresh)); });
        });
      });
  }

  // ── Intercept add-to-cart (the product form) ──
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form.product__form, form[action$="/cart/add"], form[action*="/cart/add?"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) return; // e.g. sold out — leave the form as-is
        render(res.body.sections && res.body.sections['cart-drawer']);
        open();
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-loading');
        form.submit(); // network hiccup: fall back to a normal add
      });
  });

  // ── Open on cart-icon click ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      open();
    }
  });

  // ── Delegated controls inside the drawer (survive innerHTML swaps) ──
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      close();
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      removeLine(rm.getAttribute('data-line'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

// Hero carousel: powered by Swiper (loaded from CDN in theme.liquid).
// Crossfade slideshow with arrows, indicators, autoplay, swipe, and
// pause-on-hover — all handled by Swiper's built-in modules.
(function () {
  function initCarousel(el) {
    if (typeof Swiper === 'undefined') return; // library not loaded yet
    if (el.swiper) return; // already initialised

    var reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    var loop = el.getAttribute('data-loop') === 'true';
    var autoplayOn =
      el.getAttribute('data-autoplay') === 'true' && loop && !reduceMotion;
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;

    new Swiper(el, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 800,
      loop: loop,
      grabCursor: true,
      autoplay: autoplayOn
        ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.hero-carousel__arrow--next'),
        prevEl: el.querySelector('.hero-carousel__arrow--prev'),
      },
      keyboard: { enabled: true },
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-hero-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-initialise when a section is added/changed in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

// Product carousel (featured collection): horizontal slider of product
// cards with peeking neighbours and prev/next arrows. Powered by Swiper.
(function () {
  function initCarousel(el) {
    if (typeof Swiper === 'undefined') return;
    if (el.swiper) return;

    var wrap = el.closest('.product-carousel') || el;

    new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        nextEl: wrap.querySelector('.product-carousel__arrow--next'),
        prevEl: wrap.querySelector('.product-carousel__arrow--prev'),
      },
      keyboard: { enabled: true },
      breakpoints: {
        600: { slidesPerView: 2, spaceBetween: 18 },
        900: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 24 },
      },
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-product-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  // Exposed so async-loaded content (e.g. related products) can init its carousel.
  window.__pwInitProductCarousels = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

// Related products: Shopify only fills the `recommendations` object via a
// dedicated request, so we fetch the section HTML for this product and inject
// it, then init the carousel. Empty response => nothing shows.
(function () {
  function load(el) {
    if (el.dataset.loaded === 'true') return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    el.dataset.loaded = 'true';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-related-products]');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          if (window.__pwInitProductCarousels) window.__pwInitProductCarousels(el);
          // These cards arrive after the wishlist module has run, so their
          // hearts still need waking up.
          if (window.PWWishlist) window.PWWishlist.bindHearts(el);
        }
      })
      .catch(function () {});
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-related-products]').forEach(load);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

// Collection filters: auto-apply on change, "show more" for long facet
// lists, and a mobile "Filters" toggle. Works without JS (form submits
// manually, all facets visible).
(function () {
  function initFilters(form) {
    if (form.dataset.filtersReady === 'true') return;
    form.dataset.filtersReady = 'true';
    form.classList.add('js-filters');

    // Desktop: auto-submit when a checkbox/select/price input changes.
    // Phones use the off-canvas drawer, where shoppers tick several boxes
    // and press the fixed "Apply" button at the bottom instead. The sort
    // dropdown sits in the toolbar, outside that drawer, so it has no Apply
    // button to wait for: it submits straight away on every screen size.
    var desktop = window.matchMedia('(min-width: 750px)');
    form.addEventListener('change', function (e) {
      if (desktop.matches || e.target.name === 'sort_by') form.submit();
    });

    // Mobile: open/close the off-canvas filter drawer
    var toggle = form.querySelector('[data-filters-toggle]');
    var panel = form.querySelector('[data-filters-panel]');
    var overlay = form.querySelector('[data-filters-overlay]');
    var closeBtn = form.querySelector('[data-filters-close]');

    function openDrawer() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('filters-open');
    }
    function closeDrawer() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filters-open');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', openDrawer);
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // "Show more" for facet value lists longer than their limit
    var lists = form.querySelectorAll('[data-facet-list]');
    Array.prototype.forEach.call(lists, function (list) {
      var limit = parseInt(list.getAttribute('data-facet-limit'), 10) || 6;
      var items = list.children;
      if (items.length <= limit) return;

      var expanded = false;
      function apply() {
        for (var i = limit; i < items.length; i++) {
          items[i].hidden = !expanded;
        }
      }
      apply();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'facet__more';
      btn.textContent = 'Show more';
      list.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        expanded = !expanded;
        apply();
        btn.textContent = expanded ? 'Show less' : 'Show more';
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll('[data-collection-filters]');
    Array.prototype.forEach.call(forms, initFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

// Custom select: progressive enhancement for any <select data-custom-select>.
// Builds a styled button + animated menu, keeps the native <select> for the
// form (and as a no-JS fallback), and fires a real "change" event on pick.
(function () {
  function enhance(select) {
    if (select.dataset.csReady === 'true') return;
    select.dataset.csReady = 'true';

    var align = select.getAttribute('data-select-align') || 'start';
    var wrap = document.createElement('div');
    wrap.className = 'select' + (align === 'end' ? ' select--end' : '');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    select.classList.add('select__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    function selectedText() {
      var opt = select.options[select.selectedIndex];
      return opt ? opt.text.trim() : '';
    }

    // Trigger button
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    if (select.getAttribute('aria-label')) {
      button.setAttribute('aria-label', select.getAttribute('aria-label'));
    }
    var label = document.createElement('span');
    label.className = 'select__label';
    label.textContent = selectedText();
    button.appendChild(label);
    var chevron = document.createElement('span');
    chevron.className = 'select__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    // Phosphor caret-down, matching snippets/icon.liquid (this one is built
    // here because the dropdown itself is created in JavaScript).
    chevron.innerHTML =
      '<svg class="icon icon--caret-down" viewBox="0 0 256 256" width="16" height="16" fill="currentColor" aria-hidden="true"><path d=\"M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z\"/></svg>';
    button.appendChild(chevron);
    wrap.appendChild(button);

    // Menu
    var menu = document.createElement('ul');
    menu.className = 'select__menu';
    menu.setAttribute('role', 'listbox');
    var options = [];
    Array.prototype.forEach.call(select.options, function (opt, i) {
      var li = document.createElement('li');
      li.className = 'select__option';
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');
      li.dataset.value = opt.value;
      li.textContent = opt.text.trim();
      if (i === select.selectedIndex) li.setAttribute('aria-selected', 'true');
      li.addEventListener('click', function () { choose(opt.value); });
      menu.appendChild(li);
      options.push(li);
    });
    wrap.appendChild(menu);

    function isOpen() { return wrap.classList.contains('is-open'); }
    function open() {
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick);
    }
    function close() {
      wrap.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick);
    }
    function onDocClick(e) { if (!wrap.contains(e.target)) close(); }

    function choose(value) {
      var changed = select.value !== value;
      select.value = value;
      label.textContent = selectedText();
      options.forEach(function (li) {
        if (li.dataset.value === value) li.setAttribute('aria-selected', 'true');
        else li.removeAttribute('aria-selected');
      });
      close();
      button.focus();
      if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function focusOption(i) {
      if (i < 0) i = options.length - 1;
      if (i >= options.length) i = 0;
      options[i].focus();
    }

    button.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
        var sel = options.findIndex(function (li) {
          return li.getAttribute('aria-selected') === 'true';
        });
        focusOption(sel < 0 ? 0 : sel);
      }
    });
    button.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') && !isOpen()) {
        e.preventDefault();
        open();
        focusOption(0);
      }
    });
    menu.addEventListener('keydown', function (e) {
      var i = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusOption(i + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusOption(i - 1);
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (i >= 0) choose(options[i].dataset.value);
      } else if (e.key === 'Escape') {
        close();
        button.focus();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll('select[data-custom-select]');
    Array.prototype.forEach.call(selects, enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

// Animated accordions for <details class="facet"> (filter groups + category
// tree). Uses the grid-template-rows 1fr<->0fr technique: the open state is
// the content's natural height, so there's no height measuring and therefore
// no end-snap. The native <details> is kept open and a class drives the
// collapse; without JS it falls back to the native toggle.
(function () {
  function init(details) {
    if (details.dataset.accordionReady === 'true') return;
    var summary = details.querySelector('summary');
    var panel = summary && summary.nextElementSibling;
    if (!summary || !panel || !panel.classList.contains('facet__panel')) return;
    details.dataset.accordionReady = 'true';

    var startOpen = details.hasAttribute('open');
    details.open = true; // keep content rendered; collapse is handled by a class
    apply(startOpen);

    // Enable the transition only after the initial state is painted, so groups
    // that start collapsed don't animate on page load.
    requestAnimationFrame(function () {
      details.classList.add('is-ready');
    });

    function apply(isOpen) {
      details.classList.toggle('is-collapsed', !isOpen);
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.inert = !isOpen;
    }

    // Another accordion in the same exclusive group asking this one to close.
    details.addEventListener('accordion:collapse', function () {
      apply(false);
    });

    // Inside a [data-accordion-exclusive] container (the product page tabs)
    // opening one closes the rest. Containers without the marker — the
    // collection filters — keep opening independently.
    function closeSiblings() {
      var group = details.parentElement && details.parentElement.closest('[data-accordion-exclusive]');
      if (!group) return;
      Array.prototype.forEach.call(group.querySelectorAll('details'), function (other) {
        if (other !== details) other.dispatchEvent(new CustomEvent('accordion:collapse'));
      });
    }

    summary.addEventListener('click', function (e) {
      if (e.target.closest('a')) return; // links in the summary should navigate
      e.preventDefault();
      var willOpen = details.classList.contains('is-collapsed');
      if (willOpen) closeSiblings();
      apply(willOpen);
    });
  }

  function initAll(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('details.facet, details.product__tab'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

// Expose the sticky header's height as a CSS variable so other sticky
// elements (e.g. the collection filter sidebar) can sit just below it
// instead of disappearing underneath the pinned header.
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function setHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      header.offsetHeight + 'px',
    );
  }

  setHeight();
  window.addEventListener('load', setHeight);
  window.addEventListener('resize', setHeight);
  document.addEventListener('shopify:section:load', setHeight);
})();

// Cart: auto-update quantity. Changing the quantity — by typing or using
// the minus/plus buttons — submits the cart form, so there's no separate
// "Update" button. (That button is shown only as a no-JS fallback.)
(function () {
  function init(scope) {
    var form = (scope || document).querySelector('[data-cart-form]');
    if (!form || form.dataset.cartQtyReady) return;
    form.dataset.cartQtyReady = 'true';

    // Quantity changes and removals reload the page without touching the wrap
    // line, and so does anything done in the drawer elsewhere. Settling it here
    // covers all of them with one rule instead of one fix per path.
    window.theme.syncGiftWrap().then(function (changed) {
      if (changed) window.location.reload();
    });

    function submit() {
      // Submit without a named submitter so it updates (not checkout).
      form.submit();
    }

    form.addEventListener('click', function (e) {
      var down = e.target.closest('[data-qty-down]');
      var up = e.target.closest('[data-qty-up]');
      if (!down && !up) return;
      var group = e.target.closest('[data-qty]');
      var input = group && group.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      val = up ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      submit();
    });

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) {
        var val = parseInt(e.target.value, 10);
        if (isNaN(val) || val < 0) e.target.value = 0;
        submit();
        return;
      }

      // Gift wrap: store/clear the line property, settle the €1 line, reload.
      if (e.target.matches('[data-giftwrap]')) {
        var line = parseInt(e.target.getAttribute('data-line'), 10);
        var qty = parseInt(e.target.getAttribute('data-quantity'), 10) || 1;
        // Unticking must send the key with an empty value. An empty object is
        // ignored by /cart/change.js and leaves "Ja" in place, which is why
        // unticking silently did nothing before (measured 2026-09-14). A blank
        // value counts as unwrapped both here and in the cart's Liquid.
        var props = e.target.checked ? { 'Cadeauverpakking': 'Ja' } : { 'Cadeauverpakking': '' };
        e.target.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty, properties: props }),
        })
          .then(function () { return window.theme.syncGiftWrap(); })
          .then(function () { window.location.reload(); })
          .catch(function () { e.target.disabled = false; });
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

// ---------------------------------------------------------------------------
// Product page: variant picker, thumbnail gallery, wishlist toggle.
// Accordion tabs use native <details>, no JS needed.
// ---------------------------------------------------------------------------
(function () {
  function initProduct(root) {
    if (root.__productInit) return;
    root.__productInit = true;

    // ── Gallery ──
    // Every photo is a slide in the stage (all in the DOM, lazy-loaded).
    // Desktop: the thumbnails pick which slide is shown (CSS hides the rest).
    // Phones: the stage is a horizontal scroll-snap slider; swiping updates
    // the dots, and tapping a dot scrolls to that slide.
    var stage = root.querySelector('[data-gallery-stage]');
    var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var phone = window.matchMedia('(max-width: 989px)');

    function markActive(list, index) {
      list.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        if (el.hasAttribute('data-dot')) {
          if (i === index) el.setAttribute('aria-current', 'true');
          else el.removeAttribute('aria-current');
        }
      });
    }
    function showSlide(index, scroll) {
      if (!slides[index]) return;
      markActive(slides, index);
      markActive(thumbs, index);
      markActive(dots, index);
      if (scroll && phone.matches && stage) {
        stage.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { showSlide(i, true); });
    });
    dots.forEach(function (btn, i) {
      btn.addEventListener('click', function () { showSlide(i, true); });
    });
    // Swiping: keep the dots in step with the slide that is in view
    if (stage && slides.length > 1) {
      var ticking = false;
      stage.addEventListener('scroll', function () {
        if (ticking || !phone.matches) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var index = Math.round(stage.scrollLeft / stage.clientWidth);
          index = Math.max(0, Math.min(slides.length - 1, index));
          markActive(slides, index);
          markActive(thumbs, index);
          markActive(dots, index);
        });
      }, { passive: true });
    }

    // ── Variant picker ──
    var dataEl = root.querySelector('[data-product-json]');
    if (dataEl) {
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants || [];
      var selected = (data.selected || []).slice();
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      var addBtn = root.querySelector('[data-add-button]');
      var addText = root.querySelector('[data-add-text]');
      var stockEl = root.querySelector('[data-stock]');
      var stockText = root.querySelector('[data-stock-text]');
      var groups = root.querySelectorAll('[data-option-index]');

      function findVariant(sel) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }
      // Must produce the same markup as snippets/price.liquid rendered with
      // show_badge: false, otherwise the price visibly changes design when
      // this first runs on page load.
      function priceHTML(v) {
        var cur = '<span class="price__current">' + v.price + '</span>';
        if (v.compare_at) {
          var salePrice = priceEl ? priceEl.getAttribute('data-label-sale-price') : '';
          var regularPrice = priceEl ? priceEl.getAttribute('data-label-regular-price') : '';
          return '<p class="price text-size-regular price--on-sale">'
            + '<span class="visually-hidden">' + salePrice + '</span>'
            + '<s class="price__compare">'
            + '<span class="visually-hidden">' + regularPrice + '</span>'
            + v.compare_at
            + '</s>'
            + cur
            + '</p>';
        }
        return '<p class="price text-size-regular">' + cur + '</p>';
      }
      function update() {
        // Availability per option value, given the other current selections
        groups.forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          group.querySelectorAll('[data-value]').forEach(function (btn) {
            var val = btn.getAttribute('data-value');
            var ok = variants.some(function (v) {
              if (!v.available) return false;
              return v.options.every(function (o, i) {
                return i === idx ? o === val : o === selected[i];
              });
            });
            btn.classList.toggle('is-unavailable', !ok);
            btn.classList.toggle('is-selected', val === selected[idx]);
            btn.setAttribute('aria-pressed', val === selected[idx] ? 'true' : 'false');
          });
        });

        var v = findVariant(selected);
        if (v) {
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.innerHTML = priceHTML(v);
          if (addBtn) {
            addBtn.disabled = !v.available;
            if (addText) addText.textContent = v.available
              ? addBtn.getAttribute('data-label-add')
              : addBtn.getAttribute('data-label-sold');
          }
          if (stockEl) {
            stockEl.classList.toggle('is-out', !v.available);
            if (stockText) stockText.textContent = v.available
              ? stockEl.getAttribute('data-text-in')
              : stockEl.getAttribute('data-text-out');
          }
        } else if (addBtn) {
          // Combination doesn't exist
          addBtn.disabled = true;
          if (addText) addText.textContent = addBtn.getAttribute('data-label-sold');
          if (stockEl) {
            stockEl.classList.add('is-out');
            if (stockText) stockText.textContent = stockEl.getAttribute('data-text-out');
          }
        }
      }
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            selected[idx] = btn.getAttribute('data-value');
            update();
          });
        });
      });
      update();
    }

    // The wishlist heart is handled by the shared wishlist store at the bottom
    // of this file (the same one the product cards and the header use).

    // ── Contact photo: a square sized to the block's height (flexbox +
    // aspect-ratio is unreliable for this, so measure and set it). ──
    var contact = root.querySelector('.product__contact');
    var cMedia = contact && contact.querySelector('.product__contact-media');
    var cBody = contact && contact.querySelector('.product__contact-body');
    if (cMedia && cBody) {
      var sizeContact = function () {
        var h = cBody.offsetHeight;
        cMedia.style.width = h + 'px';
        cMedia.style.height = h + 'px';
      };
      sizeContact();
      window.addEventListener('resize', sizeContact);
      var cImg = cMedia.querySelector('img');
      if (cImg && !cImg.complete) cImg.addEventListener('load', sizeContact);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(initProduct);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target.querySelector('[data-product]') || e.target); });
})();

// ─────────────────────────────────────────────────────────────────────────────
// Wishlist
//
// One store for everything: the hearts on product cards, the heart on the
// product page, the count in the header, and the wishlist page. Saved in the
// visitor's browser (localStorage) — no account or app needed — so the hearts
// are filled in by JavaScript and stay hidden without it.
// ─────────────────────────────────────────────────────────────────────────────
window.PWWishlist = (function () {
  var KEY = 'pw_wishlist';
  var EVENT = 'pw:wishlist:change';

  // Product handles. Entries used to be URL paths (/products/foo) — a path
  // can't be re-rendered into a card later, a handle can — so anything already
  // saved is converted to its last path segment on read.
  function read() {
    var raw = null;
    try { raw = window.localStorage.getItem(KEY); } catch (e) { return []; }
    var parsed;
    try { parsed = JSON.parse(raw || '[]'); } catch (e) { return []; }
    if (!Array.isArray(parsed)) return [];
    var out = [];
    parsed.forEach(function (item) {
      if (typeof item !== 'string' || !item) return;
      var handle = item.split('?')[0].split('#')[0].replace(/\/+$/, '');
      handle = handle.slice(handle.lastIndexOf('/') + 1);
      if (handle && out.indexOf(handle) === -1) out.push(handle);
    });
    return out;
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { list: list } }));
  }

  // Rewrite the stored value in handle form once, so the old path entries don't
  // have to be converted on every read. Deliberately silent — no change event,
  // nothing has actually been added or removed.
  (function migrate() {
    var raw = null;
    try { raw = window.localStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    var normalized = JSON.stringify(read());
    if (normalized === raw) return;
    try { window.localStorage.setItem(KEY, normalized); } catch (e) {}
  })();

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    if (!handle) return false;
    var list = read();
    if (list.indexOf(handle) === -1) list.push(handle);
    write(list);
    return true;
  }

  function remove(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i !== -1) list.splice(i, 1);
    write(list);
    return false;
  }

  function toggle(handle) {
    return has(handle) ? remove(handle) : add(handle);
  }

  function onChange(fn) {
    document.addEventListener(EVENT, fn);
    // Another tab changed it
    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === KEY) fn(e);
    });
  }

  // ── Hearts ──
  function paint(btn) {
    var saved = has(btn.getAttribute('data-wish-handle'));
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.getAttribute(saved ? 'data-label-remove' : 'data-label-add');
    if (label) btn.setAttribute('aria-label', label);
  }

  function bindHearts(scope) {
    (scope || document).querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      btn.hidden = false;
      if (btn.hasAttribute('data-wish-ready')) return;
      btn.setAttribute('data-wish-ready', '');
      paint(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(btn.getAttribute('data-wish-handle'));
      });
    });
  }

  function paintAll() {
    document.querySelectorAll('[data-wish-toggle]').forEach(paint);
    // Header count: written here rather than in Liquid, which can't see
    // localStorage — so a cached page never shows a stale number.
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.hidden = n === 0;
    });
  }

  function start() {
    bindHearts();
    paintAll();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function (e) { bindHearts(e.target); paintAll(); });
  onChange(paintAll);

  return {
    list: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () { return read().length; },
    onChange: onChange,
    bindHearts: bindHearts,
  };
})();

// The wishlist page. Saved handles are only in the browser, so each product's
// card is fetched from Shopify (a one-card section rendered in that product's
// context) — that way the cards are the real thing, with live prices and stock.
(function () {
  var root = document.querySelector('[data-wishlist-page]');
  if (!root) return;

  var W = window.PWWishlist;
  var grid = root.querySelector('[data-wishlist-grid]');
  var empty = root.querySelector('[data-wishlist-empty]');
  var loading = root.querySelector('[data-wishlist-loading]');
  var cardSection = root.getAttribute('data-card-section') || 'wishlist-card';
  var base = root.getAttribute('data-base') || '/';
  if (base.charAt(base.length - 1) !== '/') base += '/';
  var pending = 0;

  function setStates() {
    var showEmpty = grid.children.length === 0 && pending === 0;
    if (empty) empty.hidden = !showEmpty;
    if (loading) loading.hidden = pending === 0;
  }

  function fill(li, handle) {
    pending++;
    setStates();
    fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardSection))
      .then(function (r) {
        if (!r.ok) throw new Error(r.status === 404 ? 'gone' : 'failed');
        return r.text();
      })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        // A product that no longer exists still renders — as the card's own
        // "example product" placeholder — so that counts as gone too.
        var card = holder.querySelector('.product-card:not(.product-card--placeholder)');
        if (!card) throw new Error('gone');
        li.appendChild(card);
        W.bindHearts(li);
      })
      .catch(function (err) {
        // Deleted or unpublished: drop it for good rather than leaving a hole.
        // (Removing fires a change, which re-syncs the grid.)
        if (err && err.message === 'gone') W.remove(handle);
        throw err;
      })
      .catch(function () {
        if (li.parentNode) li.parentNode.removeChild(li);
      })
      .then(function () {
        pending--;
        setStates();
      });
  }

  // Add cards for newly saved products, drop the ones that were un-hearted.
  function sync() {
    var list = W.list();
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      if (list.indexOf(li.getAttribute('data-handle')) === -1) grid.removeChild(li);
    });
    var shown = Array.prototype.slice.call(grid.children).map(function (li) {
      return li.getAttribute('data-handle');
    });
    list.forEach(function (handle) {
      if (shown.indexOf(handle) !== -1) return;
      var li = document.createElement('li');
      li.setAttribute('data-handle', handle);
      grid.appendChild(li);
      fill(li, handle);
    });
    setStates();
  }

  sync();
  W.onChange(sync);
})();

// Newsletter signups go to Mailchimp. Its endpoint sends no CORS headers, so
// fetch() can post to it but can never read the reply — the way round that is
// the JSONP variant Mailchimp still publishes: swap /post for /post-json, name
// a callback, and load it as a <script>. None of this is required to
// subscribe; left alone the form posts normally and the visitor lands on
// Mailchimp's own confirmation page. All this buys is staying on the page.
(function () {
  var forms = document.querySelectorAll('[data-mailchimp-form]');
  if (!forms.length) return;

  var counter = 0;

  // Calls done() with Mailchimp's {result, msg} object, or null if the request
  // errored or never came back.
  function request(url, done) {
    var name = 'mailchimpReply' + counter++;
    var script = document.createElement('script');
    var settled = false;
    var timer = setTimeout(function () {
      finish(null);
    }, 10000);

    function finish(reply) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      // Left as a no-op rather than deleted: a reply that arrives after the
      // timeout would otherwise throw inside Mailchimp's own script.
      window[name] = function () {};
      if (script.parentNode) script.parentNode.removeChild(script);
      done(reply);
    }

    window[name] = finish;
    script.onerror = function () {
      finish(null);
    };
    script.src = url + '&c=' + name;
    document.body.appendChild(script);
  }

  Array.prototype.forEach.call(forms, function (form) {
    // The success line sits outside the form, so the form can be hidden and
    // replaced by it — the way the Shopify form this replaced behaved.
    var success = form.parentNode.querySelector('[data-mailchimp-success]');
    var error = form.querySelector('[data-mailchimp-error]');
    var button = form.querySelector('[type="submit"]');
    var sending = false;

    function fail(reply) {
      if (!error) return;
      var msg = reply && reply.msg ? String(reply.msg) : '';
      // Mailchimp only answers in English, and its "already subscribed" reply
      // carries a link, so the reply is matched here and the shop's own
      // wording shown instead.
      error.textContent =
        msg.indexOf('already subscribed') === -1
          ? form.getAttribute('data-message-error')
          : form.getAttribute('data-message-already');
      error.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      var endpoint = form.action.replace('/post?', '/post-json?');
      // An address this doesn't recognise is left to the browser: a plain post
      // still subscribes the visitor, just on Mailchimp's page.
      if (endpoint.indexOf('/post-json?') === -1) return;

      event.preventDefault();
      if (sending) return;
      sending = true;
      if (error) error.hidden = true;
      if (button) button.disabled = true;

      // Everything with a name: the three merge fields, the tags, and the
      // empty honeypot, which Mailchimp expects to receive untouched. The
      // consent checkbox has no name — it is a gate, not something to send.
      var query = [];
      Array.prototype.forEach.call(form.elements, function (field) {
        if (!field.name) return;
        query.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
      });

      request(endpoint + '&' + query.join('&'), function (reply) {
        sending = false;
        if (button) button.disabled = false;
        if (reply && reply.result === 'success') {
          form.hidden = true;
          if (success) success.hidden = false;
          return;
        }
        fail(reply);
      });
    });
  });
})();
